<template>
  <w-dialog :dialog-show="state" @handleClose="handleClose">
    <div slot="content" class="content">
      <div class="gpa-header flex-between">
        <span class="title">GPA计算器</span>
        <span class="iconfont iconx" @click="handleClose"/>
      </div>
      <p class="gpa-desc">为了方便 HR 衡量候选人，推荐将成绩绩点转换为4.0国际标准。将你的绩点和学校的总分标准输入到下方框内</p>
      <div class="gpa-inputs flex">
        <input v-model="point" type="text" placeholder="绩点">
        <input v-model="total" type="text" placeholder="总分">
      </div>
      <ul>
        <li>1.满分为 5.0，绩点为 3.75，在绩点框内输入3.57，在总分框内输入 5.0</li>
        <li>2.满分为 100分，绩点为 87，在绩点框内输入87，在总分框内输入 100</li>
      </ul>
      <p v-if="gpa" class="gpa-count">你的 GPA 是：{{ gpa }}</p>
      <div class="theme-button footer-btn flex-center" @click="change">转换</div>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '@/components/global/w-dialog'
	import { componentsMixin } from '@/assets/js/mixin/components'

	export default {
		name: 'GPA',
		mixins: [ componentsMixin ],
		props: {
			state: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				point: '',
				total: '',
				gpa: 0
			}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WDialog
		},
		methods: {
			handleClose () {
				this.$emit('handleClose')
      },
			change () {
				let point = Number(this.point)
				let total = Number(this.total)
				if (isNaN(point) || isNaN(total) || !point || !total) {
					this.showToast('请正确输入绩点和总分')
				} else {
					this.gpa = (point / total * 4).toFixed(2)
          if (this.gpa > 4) this.gpa = 4
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .content {
    padding: 24px;
    border-radius: 4px;
    background-color: $color-light;
    width: 90vw;
    box-sizing: border-box;
    .gpa-header {
      margin-bottom: 24px;
      .title {
        font-size: $font-size-large;
        color: $color-title;
        font-weight: 500;
        line-height: 26px;
      }
      .iconfont {
        color: #9C9C9C;
        font-size: 18px;
      }
    }
    .gpa-desc {
      color: $color-dark-gray;
      line-height: 20px;
      margin-bottom: 8px;
    }
    .gpa-inputs {
      align-items: center;
      margin-bottom: 16px;
      input {
        width: 50%;
        height: 40px;
        padding-left: 16px;
        border: 1px solid #ECECEC !important;
        &::placeholder {
          color: #BCBCBC;
        }
        &:first-child {
          margin-right: 16px;
        }
      }
    }
    ul {
      font-size: $font-size-small;
      color: $color-dark-gray;
      line-height: 24px;
      margin-bottom: 16px;
      li {
        list-style: none;
      }
    }
    .gpa-count {
      color: $color-title;
      font-weight: 500;
      line-height: 20px;
    }
    .footer-btn {
      height: 38px;
      border-radius: 2px;
      margin-top: 16px;
      font-size: $font-size-medium-x;
    }
  }
</style>
